import type { Schedule } from '../../services/adminApi';

export function sameSchedulePrefix(a?: string, b?: string): boolean {
  const normalize = (name?: string) => {
    const raw = (name || '').toLowerCase().trim();
    return raw
      .replace(/\b(primary on-?call|escalation)\b/g, '')
      .replace(/[()]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  };

  const na = normalize(a);
  const nb = normalize(b);
  return na.length > 0 && nb.length > 0 && na === nb;
}

export function getLinkedEscalation(
  primary: Schedule,
  schedules: Schedule[],
): { linked: Schedule | null; mode: 'persisted' | 'heuristic' | null } {
  if (primary.scheduleType !== 'Primary') {
    return { linked: null, mode: null };
  }

  const persisted = schedules
    .filter(
      (s) =>
        s.scheduleType === 'Escalation' &&
        s.scheduleId !== primary.scheduleId &&
        s.linkedPrimaryScheduleId === primary.scheduleId,
    )
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }))[0] || null;

  if (persisted) {
    return { linked: persisted, mode: 'persisted' };
  }

  const fallback =
    schedules.find(
      (s) =>
        s.scheduleType === 'Escalation' &&
        s.scheduleId !== primary.scheduleId &&
        !s.linkedPrimaryScheduleId &&
        sameSchedulePrefix(s.name, primary.name),
    ) || null;

  if (fallback) {
    return { linked: fallback, mode: 'heuristic' };
  }

  return { linked: null, mode: null };
}
